import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { BasePageView } from "by/gamefactory/cityversetycoon/scenes/common/components/BasePageView";
import gsap from "gsap";
import { IDestroyOptions } from "pixi.js";

export class MyWalletPage extends BasePageView {
    private static readonly ANIMATION_DURATION = 0.15;

    private readonly viewAnimation: gsap.core.Timeline;

    public constructor(canvasScaler: ICanvasScaler) {
        super(canvasScaler);
        this.viewAnimation = new gsap.core.Timeline({ paused: true });
        this.viewAnimation.fromTo(this, { alpha: 0 }, { alpha: 1, ease: 'power1.inOut' });
    }

    public async show(duration?: number): Promise<void> {
        this.viewAnimation.duration(duration ?? MyWalletPage.ANIMATION_DURATION);
        await this.viewAnimation.play();
    }

    public async hide(duration?: number): Promise<void> {
        this.viewAnimation.duration(duration ?? MyWalletPage.ANIMATION_DURATION);
        await this.viewAnimation.reverse();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.viewAnimation.kill();
        super.destroy(options);
    }
}